// @ts-nocheck
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material';
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { BookingListHead, BookingListToolbar, BookingMoreMenu } from '../sections/@dashboard/bookings';
import USERLIST from '../_mock/user';
import { cancellations as CANCELLATIONS } from '../_mock/bookings';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { getAuthDetails } from '../store/state/authSlice';
import {
  useApproveCancelBookingByServiceProviderMutation,
  useGetAllBookingDetailBySearchCriteriaMutation,
} from '../store/api/bookingsApi';
import { getbookingSpaces, getBookingTotalRecords, setBookings } from '../store/state/bookingSlice';
import toast from 'react-hot-toast';
import Loading from '../components/Loading';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TABLE_HEAD = [
  { id: 'bookingCode', label: 'Booking Code', alignRight: false },
  { id: 'customerName', label: 'Customer Name', alignRight: false },
  // { id: 'parkingName', label: 'Parking Space Name', alignRight: false },
  { id: 'role', label: 'Amount', alignRight: false },
  { id: 'name', label: 'Reason', alignRight: false },
  { id: 'isVerified', label: 'Type', alignRight: false },
  { id: 'status1', label: 'Vendor Approval', alignRight: false },
  { id: '' },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.id.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function Cancellations() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const currentUser = useAppSelector(getAuthDetails);

  const [customerName, setCustomerName] = useState('');

  const [getAllBookingDetailBySearchCriteria, getAllResponse] = useGetAllBookingDetailBySearchCriteriaMutation();
  const [approveCancelBookingByServiceProvider, vendorApproveResponse] =
    useApproveCancelBookingByServiceProviderMutation();
  const BookingData = useAppSelector(getbookingSpaces);
  const [cancellations, setAllCancellations] = useState();
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const bookingTotalRecords = useAppSelector(getBookingTotalRecords);
  const dispatch = useAppDispatch();

  const getCancellationDetailsAsync = async (
    flag,
    offset,
    sortOrder,
    newPage,
    columnName,
    serviceProviderId,
    customerName
  ) => {
    await getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: {
        columnName: columnName,
        offset: offset,
        page: newPage,
        orderBy: sortOrder,
        flag: flag,
        customerName: customerName,
        serviceProviderId: serviceProviderId,
      },
    });
  };

  useEffect(() => {
    getCancellationDetailsAsync('CANCEL_REVIEW_BOOKING', rowsPerPage, orderBy, page, 'id', token.serviceProviderId, '');
    setFilterName('')
  }, []);

  // useEffect(() => {
  //   getAllBookingDetailBySearchCriteria({
  //     token: token,
  //     payload: {
  //       columnName: 'id',
  //       offset: rowsPerPage,
  //       page: page,
  //       orderBy: orderBy,
  //       flag: 'CANCEL_REVIEW_BOOKING',
  //       serviceProviderId: serviceProviderId,
  //     },
  //   });
  // }, []);

  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setBookings(getAllResponse.data));
    }
  }, [getAllResponse.isSuccess]);

  useEffect(() => {
    if (BookingData) {
      setAllCancellations(BookingData);
    }
  }, [BookingData]);

  useEffect(() => {
    if (vendorApproveResponse.isSuccess) {
      getCancellationDetailsAsync(
        'CANCEL_REVIEW_BOOKING',
        rowsPerPage,
        orderBy,
        page,
        'id',
        token.serviceProviderId,
        ''
      );
      toast.success('Cancellation approved');
    }
  }, [vendorApproveResponse.isSuccess]);

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    await getCancellationDetailsAsync(
      'CANCEL_REVIEW_BOOKING',
      rowsPerPage,
      orderBy,
      newPage,
      'id',
      token.serviceProviderId,
      ''
    );
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    getCancellationDetailsAsync(
      'CANCEL_REVIEW_BOOKING',
      rowsPerPage,
      isAsc ? 'desc' : 'asc',
      0,
      'id',
      token.serviceProviderId,
      ''
    );
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getCancellationDetailsAsync(
      'CANCEL_REVIEW_BOOKING',
      parseInt(event.target.value, 10),
      orderBy,
      0,
      'id',
      token.serviceProviderId,
      ''
    );
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setCustomerName(event.target.value);
      getCancellationDetailsAsync(
        'CANCEL_REVIEW_BOOKING',
        rowsPerPage,
        orderBy,
        page,
        'id',
        token.serviceProviderId,
        event.target.value
      );
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - cancellations.length) : 0;

  const filteredUsers = cancellations ? cancellations : [];

  const isUserNotFound = filteredUsers.length === 0;

  const capitalize = (value: any) => {
    if (value) {
      return value
        .match(/\b(\w)/g)
        .join('')
        .toUpperCase();
    }
  };

  return (
    <Page title="Cancellations">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Cancellation
          </Typography>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              navigate('/dashboard/bookings', { replace: true });
            }}
            sx={{ marginBottom: '10px' }}
            size="medium"
          >
            <ArrowBackIcon />
          </Button>
        </Stack>

        <Card>
          <BookingListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            placeholder={'Search By Customer Name'}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <BookingListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={cancellations?.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredUsers.map((row) => {
                    const {
                      id,
                      name,
                      bookingCode,
                      role,
                      status,
                      avatarUrl,
                      isVerified,
                      parkingSpaceLocationRespDTO,
                      parkingSlotRespDTO,
                      customerDetailResponseDTO,
                      parkingLocationId,
                      serviceProviderId,
                      customerId,
                      bookingAmount,
                      cancellationReasonName,
                      cancelBookingByAdmin,
                      cancelBookingByServiceProvider,
                      totalAmount,
                    } = row;
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell align="left">{bookingCode}</TableCell>
                        <TableCell align="left">{customerDetailResponseDTO?.name}</TableCell>
                        {/* <TableCell align="left">{parkingSpaceLocationRespDTO?.name}</TableCell> */}
                        {/* <TableCell align="left">
                          {capitalize(parkingSpaceLocationRespDTO?.name)}-{parkingSlotRespDTO?.slotId}
                        </TableCell>
                        <TableCell align="left">{parkingSlotRespDTO?.slotId}</TableCell> */}
                        <TableCell align="left">₹{totalAmount?.toFixed(2)}</TableCell>
                        <TableCell align="left">{cancellationReasonName}</TableCell>
                        <TableCell align="left">{isVerified ? 'Verified' : 'Not Verified'}</TableCell>
                        <TableCell align="left">
                          <Button
                            variant="contained"
                            color="success"
                            disabled={cancelBookingByAdmin || cancelBookingByServiceProvider}
                            onClick={() => {
                              approveCancelBookingByServiceProvider({
                                token: token.token,
                                bookingId: id,
                                customerId: customerId,
                                parkingSpaceLocationId: parkingLocationId,
                                serviceProviderId: serviceProviderId,
                              });
                            }}
                          >
                            Approve
                          </Button>
                          {/* )} */}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={bookingTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      {getAllResponse.isLoading || vendorApproveResponse.isLoading ? <Loading /> : null}
    </Page>
  );
}
